<template>
  <div class="trezo-card-dropdown relative">
    <button
      type="button"
      :class="{
        'trezo-card-dropdown-btn inline-block transition-all text-[26px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500': true,
        active: isActive,
      }"
      id="dropdownToggle"
      @click.stop="toggleActive"
    >
      <i class="ri-more-fill"></i>
    </button>
    <ul
      class="trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
    >
      <li>
        <button
          type="button"
          class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
        >
          Save Post
        </button>
      </li>
      <li>
        <button
          type="button"
          class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
        >
          Hide Post
        </button>
      </li>
      <li>
        <button
          type="button"
          class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
        >
          Report Post
        </button>
      </li>
      <li>
        <button
          type="button"
          class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
        >
          Block Cynthia
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useClickOutside } from "@/utils/useClickOutside";

export default defineComponent({
  name: "DropdownToggleBtn",
  setup() {
    const { isActive, toggleActive } = useClickOutside("dropdownToggle");

    return {
      isActive,
      toggleActive,
    };
  },
});
</script>
